import React from "react";

import useNetwork from "../../Hooks/useNetwork";
import WalletNotConnected from "../../components/WalletNotConnected/WalletNotConnected";
import EditProfileSection from "../../sections/EditProfile/EditProfileSection/EditProfileSection";

const EditProfilePage = () => {
  const { isConnected, validChain } = useNetwork();

  return (
    <div>
      {isConnected && validChain ? (
        <EditProfileSection />
      ) : (
        <WalletNotConnected />
      )}
    </div>
  );
};

export default EditProfilePage;
